<template>
  <div>
    <div class="py-2 pl-4">
      <span class="weather-alert-title">Alertas meteorológicos</span>
    </div>

    <div v-if="alertsActiveMenu.length == 0" class="ma-3 info-alert">
      <div class="pa-1 d-flex">
        <div class="d-flex align-start">
          <v-icon color="#FFFFFF">icon-alertadis-info-circle</v-icon>
        </div>
        <div class="pl-2">
          <p class="alert-title">Nenhum alerta vigente</p>
     <!--      <p class="alert-message">
            Não há alertas vigentes entre os níveis A5 e A10.
          </p> -->
        </div>
      </div>
    </div>

    <div v-for="(alert, i) in alertsActiveMenu" :key="i">
      <div v-for="(note, index) in alert.data" :key="index" class="mx-4 pt-2">
        <span class="note-date">{{ note.date }}</span>
        <v-row no-gutters class="d-flex align-center">
          <v-col cols="3">
            <div
              :style="`border: 2px solid ${alertColor(note.type)}`"
              style="border-radius: 4px; width: 33px; height: 33px"
              class="d-flex justify-center align-center"
            >
              <span
                class="note-type"
                :style="`color: ${alertColor(note.type)}`"
                >{{ note.type }}</span
              >
            </div>
          </v-col>
          <v-col cols="9" class="d-flex flex-column">
            <span class="note-name">{{
              alert.companyZoneName.replace("Copeldis - Regional", "")
            }}</span>
            <span class="note-percentage"
              >{{ note.alertArea }}% da regional</span
            >
          </v-col>
        </v-row>
        <v-row no-gutters class="pt-2"
          ><span class="note-validity"
            >VIGÊNCIA: {{ note.validityLabel }}</span
          ></v-row
        >
        <v-row no-gutters class="pt-2 pb-4 d-flex align-center">
          <v-icon size="14" color="accent lighten-1"
            >icon-alertadis-angle-double-right</v-icon
          >
          <a class="pl-2 note-details" @click="detailsAlerts"
            >Detalhar alerta</a
          >
        </v-row>
        <v-divider class="pb-2"></v-divider>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import router from "@/router";
export default {
  data: () => ({
    isProduction: process.env.NODE_ENV === "production",
  }),

  computed: {
    ...mapGetters(["alertsActiveMenu", "detailsWeatherAlerts"]),
    ...mapMutations(["setDetailsAlerts"]),
  },
  methods: {
    detailsAlerts() {
      if (router.currentRoute.name !== "Monitoring") {
        router.push("/Monitoring");
      }

      this.$store.commit("setDetailsAlerts", !this.detailsWeatherAlerts);
      this.$store.commit("changeDetailsAlertsMounted", true);
    },
    alertColor(type) {
      switch (type) {
        case "T1":
          return "#CDDC39";
        case "T2":
          return "#CDDC39";
        case "T3":
          return "#FDE047";
        case "T4":
          return "#FDE047";
        case "T5":
          return "var(--v-alertT5_T6-base)";
        case "T6":
          return "var(--v-alertT5_T6-base)";
        case "T7":
          return "var(--v-alertT7_T8-base)";
        case "T8":
          return "var(--v-alertT7_T8-base)";
        case "T9":
          return "var(--v-alertT9_T10-base)";
        case "T10":
          return "var(--v-alertT9_T10-base)";
        default:
          return "var(--v-primary-base)";
      }
    },
  },
};
</script>

<style scoped>
.weather-alert-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: var(--v-primary-base);
}

.info-alert {
  background-color: "#191C29";
  border-radius: 8px;
}

.alert-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: "FFFFFF";
}

.alert-message {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: "#FFFFFF"
}

.note-date {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--v-primary-darken2);
}

.note-type {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 26px;
  letter-spacing: 0.15px;
}

.note-name {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: 0.15px;
  color: var(--v-primary-base);
}

.note-percentage {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--v-primary-darken2);
}

.note-description {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-base);
}

.note-validity {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--v-highlight80-base);
}

.note-details {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-accent-lighten1);
}
</style>